//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod
const GetCheckOperatorList = () =>
    request({
        url: ApiURL.Query.GetCheckOperatorList,
        method: RequestType.GET,
        //params:params,
    });
const GetCountryList = () =>
    request({
        url: ApiURL.Query.GetCountryList,
        method: RequestType.GET,
        //params:params,
    });

const GetRegionalCountryList = (languageCode: string | null = 'en-us') =>
    request({
        url: `${ApiURL.Query.GetRegionalCountryList}?LanguageCode=${languageCode}`,
        method: RequestType.GET,
        //  params:params,
    });

const GetAllActiveCountryLanguagesForBackoffice = (instanceId: number) =>
    request({
        url: `${ApiURL.Query.GetAllActiveCountryLanguagesForBackoffice}?instanceid=${instanceId}`,
        method: RequestType.GET,
        //  params:params,
    });

const CacheQuery = {
    GetCheckOperatorList,
    GetCountryList,
    GetRegionalCountryList,
    GetAllActiveCountryLanguagesForBackoffice,
};

export default CacheQuery;
